module.exports = __webpack_public_path__ + "static/media/word.581e353b.png";